import { WeightedItem } from "../components/weighted-list"

export const randomItem = (listOfItems: WeightedItem[]) => {
    // https://www.geeksforgeeks.org/how-to-select-a-random-element-from-array-in-javascript/
    const listSize: number = listOfItems.length;
    const randomItemIndex: number = Math.floor(Math.random() * listSize);
    return listOfItems[randomItemIndex];
}